import { render, staticRenderFns } from "./drawer-content.component.vue?vue&type=template&id=f88af806&scoped=true&"
import script from "./drawer-content.component.vue?vue&type=script&lang=ts&"
export * from "./drawer-content.component.vue?vue&type=script&lang=ts&"
import style0 from "./drawer-content.component.vue?vue&type=style&index=0&id=f88af806&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f88af806",
  null
  
)

export default component.exports